import React, { FC, ReactElement } from 'react';
import { useIntl } from 'umi';
import { Layout } from 'tea-component';
import { MENU_LIST } from "../_config/sideMenus";
import LeftMenu from '@/pages/home/components/LeftMenu';
import { handleFlatMapRouter } from '../utils/utils';
import { useCreation } from 'ahooks';
import { compact } from 'lodash-es';
const { Body, Content } = Layout;

interface IProps {
  [key: string]: unknown;
}
const Aigc: FC<IProps> = ({ children }): ReactElement => {
  const { locale } = useIntl();
  const isEn = locale === "en-US";
  const title = isEn ? 'AIGC+Game' : 'AIGC+Game';
  const menuList = useCreation(
    () => compact(handleFlatMapRouter(MENU_LIST, locale)),
    [locale],
  );
  return (
    <>
      <Body className="layout__body">
        <LeftMenu {...{ menuList, title }} />
        <Content>{children}</Content>
      </Body>
    </>
  );
};
export default Aigc;
